import Api from "./api"
import Source from "./source"
import Device from "./device"
import App from "./app"
import _Event from "./event"
import Hls from "./hls"
import Common from "./common"

class Universal {
  constructor() {
    this._api = new Api()
    this._source = new Source()
    this._device = new Device()
    this._common = new Common()
    this._app = new App()
    this._event = new _Event()
    this._multicast = null
    this._rf = null
    this._hls = new Hls()
    this._vod = this._hls
  }
}

export default new Universal()
